import { useQuery } from '@tanstack/react-query';
import type { PaymentSchemesDto } from '../../models/payment-schemes/payment-schemes.dto';
import apiRequest from '../../services/apiWrapper';
import { PAYMENT_SCHEMES_URL } from '../../utils/constants/urlConstants';

async function getPaymentSchemeById(id: string | null) {
  const response = await apiRequest.get<PaymentSchemesDto>(
    `${PAYMENT_SCHEMES_URL}/${id}`
  );

  return response.data;
}

export function useGetPaymentSchemeById(
  id: string | null,
  enabled: boolean = true
) {
  return useQuery({
    queryKey: ['payment-schemes', id],
    queryFn: () => getPaymentSchemeById(id),
    enabled,
  });
}
